import { render, staticRenderFns } from "./fileManagementGuoJiao.vue?vue&type=template&id=62745469&scoped=true"
import script from "./fileManagementGuoJiao.vue?vue&type=script&lang=js"
export * from "./fileManagementGuoJiao.vue?vue&type=script&lang=js"
import style0 from "./fileManagementGuoJiao.vue?vue&type=style&index=0&id=62745469&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62745469",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62745469')) {
      api.createRecord('62745469', component.options)
    } else {
      api.reload('62745469', component.options)
    }
    module.hot.accept("./fileManagementGuoJiao.vue?vue&type=template&id=62745469&scoped=true", function () {
      api.rerender('62745469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/fileManagementGuoJiao.vue"
export default component.exports